/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button, Input, Space, Tooltip, Table, Skeleton } from 'antd';
import { EyeOutlined, FormOutlined, SearchOutlined } from '@ant-design/icons';
// import SideCalendar from '../../components/side-calendar/SideCalendar';
import NoticeBoardSlide from '../../components/notice-board/NoticeBoardSlide';
import Utils from '../../misc/Utils';
import Enums from '../../misc/Enums';
import { Link } from 'react-router-dom';
import Highlighter from 'react-highlight-words';
import ResponsiveBreadcrumb from '../../components/breadcrumb/ResponsiveBreadcrumb';
import '../common/BraineeModule.css';
import './Survey.css';

export function Survey(props) {
   const user_id = Utils.getCurrentUserInfo(Enums.UserInfo.id);

   const [searchText, setSearchText] = React.useState("");
   const [searchedColumn, setSearchedColumn] = React.useState("");
   const [surveyAssignedList, setSurveyAssignedList] = useState([]);
   const [surveyListLoading, setSurveyListLoading] = useState(false);


   useEffect(() => {
      Utils.verifyJwt();

      getSurveys();

   }, []);

   const handleSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
      setSearchText(selectedKeys[0]);
      setSearchedColumn(dataIndex);
   };

   const handleReset = clearFilters => {
      clearFilters();
      setSearchText("");
   };

   const getColumnSearchProps = dataIndex => ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
         <div style={{ padding: 8 }}>
            <Input
               ref={node => {
                  //this.searchInput(node);
               }}
               placeholder={`Search ${dataIndex}`}
               value={selectedKeys[0]}
               onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
               onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
               style={{ width: 188, marginBottom: 8, display: 'block' }}
            />
            <Space>
               <Button
                  type="primary"
                  onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                  icon={<SearchOutlined />}
                  size="small"
                  style={{ width: 90 }}>
                  Search
               </Button>
               <Button
                  size="small"
                  style={{ width: 90 }}
                  // onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}
                  onClick={() => {
                     handleReset(clearFilters);
                     confirm({ closeDropdown: false });
                     setSearchText(selectedKeys[0]);
                     setSearchedColumn(dataIndex);
                  }}
               >
                  Reset
               </Button>
            </Space>
         </div>
      ),
      filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
      onFilter: (value, record) =>
         record[dataIndex]
            ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
            : '',
      // onFilterDropdownVisibleChange: visible => {
      //    if (visible) {
      //       setTimeout(() => this.searchInput.select(), 100);
      //    }
      // },
      render: text =>
         searchedColumn === dataIndex ? (
            <Highlighter
               highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
               searchWords={[searchText]}
               autoEscape
               textToHighlight={text ? text.toString() : ''}
            />
         ) : (
            text
         ),
   });

   const ReportCardsListColumns = [
      {
         title: '',
         dataIndex: 'survey_link',
         key: 'survey_link',
         hidden: true,
      },
      {
         title: 'Teacher',
         key: 'surveyee_name',
         dataIndex: 'surveyee_name',
         sorter: (a, b) => { return a.surveyee_name.localeCompare(b.surveyee_name) },
         width: '20%',
         ...getColumnSearchProps('surveyee_name')
      },
      {
         title: 'Description',
         key: 'description',
         dataIndex: 'description',
         sorter: (a, b) => { return a.description.localeCompare(b.description) },
         width: '25%',
         ...getColumnSearchProps('description')
      },
      {
         title: 'Level',
         key: 'level_name',
         dataIndex: 'level_name',
         sorter: (a, b) => { return a.level_name.localeCompare(b.level_name) },
         width: '15%',
         ...getColumnSearchProps('level_name')
      },
      {
         title: 'Section',
         key: 'section_name',
         dataIndex: 'section_name',
         sorter: (a, b) => { return a.section_name.localeCompare(b.section_name) },
         width: '15%',
         ...getColumnSearchProps('section_name')
      },
      {
         title: 'Assigned By',
         key: 'assigned_by_name',
         dataIndex: 'assigned_by_name',
         sorter: (a, b) => { return a.assigned_by_name.localeCompare(b.assigned_by_name) },
         width: '20%',
         ...getColumnSearchProps('assigned_by_name')
      },
      {
         title: 'Action',
         key: 'action',
         render: payload => {
            return (
               <>
                  <Space size="small">
                     <Tooltip placement="top" title={'View Survey'}>
                        <Button
                           type="text"
                           shape="circle"
                           className="survey-action-btn"
                           icon={<EyeOutlined />}
                           onClick={() => handleViewSurvey(payload.survey_link)}
                        />
                     </Tooltip>
                  </Space>
               </>
            );
         },
         width: '25%'
      },
   ].filter(item => !item.hidden);

   const getSurveys = () => {
      setSurveyListLoading(true);
      axios.get(`${process.env.REACT_APP_API_SCHOOL_MANAGEMENT}/getsurveyassignedstudent?studentid=${user_id}`).then((response) => {
         if (response.data) {
            const data = response.data;
            setSurveyAssignedList(data);
         }
         setSurveyListLoading(false);
      }, (error) => {
         console.log(error.message);
         setSurveyListLoading(false);
      });
   }

   const handleViewSurvey = (link) => {
      window.open(link, '_blank').focus();
   }

   const renderSkeletonTable = () => (
      <div className="brainee-module-skeleton-table survey-skeleton-table">
         <div className="brainee-module-skeleton-header">
            <Skeleton.Input active size="small" className="brainee-module-skeleton-title" />
            <Skeleton.Input active size="small" className="brainee-module-skeleton-chip" />
            <Skeleton.Input active size="small" className="brainee-module-skeleton-cell" />
            <Skeleton.Input active size="small" className="brainee-module-skeleton-action" />
         </div>
         {[0, 1, 2, 3, 4].map((item) => (
            <div className="brainee-module-skeleton-row survey-skeleton-row" key={item}>
               <Skeleton.Input active size="small" className="brainee-module-skeleton-cell is-wide" />
               <Skeleton.Input active size="small" className="brainee-module-skeleton-cell" />
               <Skeleton.Input active size="small" className="brainee-module-skeleton-cell" />
               <Skeleton.Button active size="small" className="brainee-module-skeleton-action" />
            </div>
         ))}
      </div>
   );

   return (
      <>
         <div className="dashboard-area-all brainee-module-page survey-page">
            <div className="dashboard-item brainee-module-shell survey-shell">
               <div className="brainee-module-breadcrumb">
                  <ResponsiveBreadcrumb
                     items={[
                        { key: 'home', node: <Link to="/home">Home</Link> },
                        { key: 'teacher-survey', node: 'Teacher Survey' },
                     ]}
                  />
               </div>

               <section className="brainee-module-hero survey-hero">
                  <div>
                     <span className="brainee-module-kicker">Survey</span>
                     <h1>Teacher Survey</h1>
                     <p>Open assigned surveys and share feedback for the teachers and classes connected to your account.</p>
                     <div className="brainee-module-meta">
                        <span><strong>{surveyListLoading ? '...' : surveyAssignedList.length}</strong> {surveyListLoading ? 'Loading surveys' : 'Assigned surveys'}</span>
                     </div>
                  </div>
                  <div className="survey-hero-icon" aria-hidden="true">
                     <FormOutlined />
                  </div>
               </section>

               <section className="brainee-module-panel survey-panel">
                  <div className="brainee-module-panel-header">
                     <div>
                        <span className="brainee-module-kicker">Records</span>
                        <h2>Assigned surveys</h2>
                     </div>
                     <span className="brainee-module-count">{surveyListLoading ? '...' : surveyAssignedList.length}</span>
                  </div>

                  {surveyListLoading ? (
                     renderSkeletonTable()
                  ) : (
                     <div className="brainee-module-table-shell">
                        <Table
                           className="brainee-module-table survey-table"
                           rowKey={'uid'}
                           size='small'
                           columns={ReportCardsListColumns}
                           dataSource={surveyAssignedList}
                           pagination={false}
                           scroll={{
                              x: '900px',
                              y: 'calc(100svh - 25rem)',
                           }}
                           footer={() => <div className="brainee-module-table-footer"><span>Total Records: {surveyAssignedList.length}</span></div>}
                        />
                     </div>
                  )}
               </section>
            </div>
         </div>

         {/* <div className="notice-area">
            <div className="notice-item">
               <SideCalendar />
               <NoticeBoard />
            </div>
         </div> */}
      </>
   );
}
